var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{staticClass:"filter-tree",attrs:{"data":_vm.documents,"props":_vm.defaultProps},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('span',{staticClass:"custom-tree-node"},[(data.documents)?_c('folder-list-item',{attrs:{"folder":data}}):_c('document-item',{attrs:{"document":data,"user":_vm.user}})],1)}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }